import { createFormState, required } from "redux-freeform";
import { emailFormatValidators } from "../../../util/emailValidators";

const formConfig = {
  email: {
    validators: [required(), ...emailFormatValidators]
  },
  password: {
    validators: [required()]
  }
};

export const { reducer, mapStateToProps, mapDispatchToProps } = createFormState(
  formConfig
);
